<template>
  <div class="entry-platform-container">
    <div class="slider_container">
      <el-carousel :height="sliderStyle.height" indicator-position="none">
        <el-carousel-item v-for="(item, index) in sliders" :key="index">
          <div class="slider-wrapper">
            <img :src="baseUrl + item.imageUrl" class="slider_img" @click="turnToTarget(item)">
            <div class="day-counter">
              <span class="day-number">{{ getDayCount }}</span>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="platform-info">
      <div class="platform-input-info">
        <h3>工程师之家入驻—商家入驻</h3>
        <h4>填写入驻信息，将有专业的客服团队联系您</h4>
        <el-row :gutter="15">
          <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-width="140px">
            <el-form-item label="公司/企业名称" prop="name">
              <el-input v-model="formData.name" placeholder="请输入公司/企业名称" clearable :style="{width: '100%'}">
              </el-input>
            </el-form-item>
            <el-form-item label="营业执照注册号" prop="businessLicenseRegistrationNumber">
              <el-input v-model="formData.businessLicenseRegistrationNumber" placeholder="请输入营业执照注册号" clearable :style="{width: '100%'}">
              </el-input>
            </el-form-item>

            <el-form-item label="公司/企业联系人" prop="userName">
              <el-input v-model="formData.userName" placeholder="请输入公司/企业联系人" clearable :style="{width: '100%'}">
              </el-input>
            </el-form-item>
            <el-form-item label="电子邮箱地址" prop="email">
              <el-input v-model="formData.email" placeholder="请输入电子邮箱地址" clearable :style="{width: '100%'}">
              </el-input>
            </el-form-item>
            <el-form-item label="联系人手机号" prop="mobile">
              <el-input v-model="formData.mobile" placeholder="请输入联系人手机号" clearable :style="{width: '100%'}">
              </el-input>
            </el-form-item>
            <el-col :span="24" class="code-item">
              <el-form-item label="验证码" prop="code">
                <el-input v-model="formData.code" placeholder="请输入验证码" clearable :style="{width: '100%'}">
                </el-input>
              </el-form-item>
              <el-form-item class="get-code-btn">
                <el-button type="success" size="medium" @click="getMobileCode" class="mobile_code_button">
                  <span v-if="!getCoding" class="ng-binding">{{codeTime}}秒后重新获取</span>
                  <span v-else>
                    获取验证码
                  </span>
                </el-button>
              </el-form-item>
            </el-col>

            <el-form-item label="公司注册地/省" prop="privince">
              <el-select v-model="formData.privince" @change="proviceChage" placeholder="请选择公司注册地/省" clearable :style="{width: '100%'}">
                <el-option v-for="(item, index) in privinceOptions" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公司注册地/市" prop="city">
              <el-select v-model="formData.city" @change="cityChage" placeholder="请选择公司注册地/市" clearable :style="{width: '100%'}">
                <el-option v-for="(item, index) in cityOptions" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公司注册地/区" prop="district">
              <el-select v-model="formData.district" placeholder="请选择公司注册地/区" clearable :style="{width: '100%'}">
                <el-option v-for="(item, index) in districtOptions" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-button type="success" class="submit" :disabled="!checked" @click="submitForm">发送</el-button>
            <div class="agreement-wrap">
              <label class="agreement-checkbox">
                <span :class="['ant-checkbox', checked && 'ant-checkbox-checked']" @click="changeCheckbox">
                  <input type="checkbox" class="ant-checkbox-input" />
                  <span class="ant-checkbox-inner"></span>
                </span>
                <span>我已阅读并同意</span>
              </label>
              <a @click="openDoc('企业用户会员服务许可协议','3')">《"工程师之家"  企业用户会员服务许可协议》</a>
              <a @click="openDoc('隐私保护政策','2')">《"工程师之家"隐私保护政策》</a>
            </div>
          </el-form>
        </el-row>
      </div>
      <div class="platform-desc">
        <div class="platform-desc-info">
          <h3>为什么选择工程师之家？</h3>
          <p>工程师之家，服务与众不同</p>
          <p>全方位营销顾问服务和客户支持，让您放心无忧</p>
          <p>无论是营销建议、问题咨询或者广告战役监控评估，我们都将致力于为您提供卓越客户体验</p>
          <p>与我们分享您的商业目标、困难和挑战</p>
          <p>我们将为您定制个性化营销服务方案，为您的成功助一臂之力</p>

          <!-- <div class="platform-desc-info-text">
            <span>产品个绍<br />主要特点和竞争优势。高速、高效超声波和通轴MQL功能可选刀库容纳量可定制 (21/26/30/36把刀具)主轴鼻端到工作台的距离可定制 (200-560mm/270-630mm/340-700mm)更高的精度</span>
            <span>应用<br />用于加工各种类型的金属工件(铝、铜、钢、钦、铸铁等)应用行业。3C、航空航天、高端医疗、汽车、新能源、5G等</span>
          </div> -->
        </div>
        <div class="platform-desc-info">
          <h3>我们的使命！</h3>
          <p>每一个项目研发的成功，是我们不懈的追求。</p>
          <p>为了帮助研发项目经理作出高效及正确的设计选择。</p>
          <p>我们在全球搜集并臻选优质生产商的专业工业产品。</p>
          <p>建立智能的工业零部件大数据及智能体系统。</p>
          <p>加速来自不同国家的不同规模的研发项目。</p>
          <p>是我们每一天工作的动力和不懈的追求。</p>
        </div>
      </div>
    </div>
    <el-dialog
      title="用户信息提交成功"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>恭喜您入驻成功！</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="entrySuccess">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 文档查看对话框 -->
    <el-dialog
      :title="docTitle"
      :visible.sync="docDialogVisible"
      width="70%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :modal-append-to-body="false"
      custom-class="doc-dialog">
      <docx-viewer
        v-if="docDialogVisible"
        :doc-path-key="docPath"
        :file-name="docFileName"
      />
    </el-dialog>
  </div>
</template>
<script>
import { GetCode } from '../api/login/api'
import { GetBannerList  } from '../api/home/api'
import { baseUrl } from '../utils'
import { CompanyAdd, GetProvinceList, GetCityList, GetCountyList } from '../api/company/api'
import DocxViewer from './public/docx.vue'

  export default {
    name: 'Index',
    components: {
      DocxViewer
    },
    data() {
      return {
        dialogVisible: false,
        baseUrl,
        getCoding: true,
			  codeTime: 60,
        checked: false,
        docDialogVisible: false,
        docTitle: '',
        docPath: '3',
        docFileName: '工程师之家企业用户会员服务许可协议.docx',
        sliders: [],
        sliderStyle: {},
        formData: {
          userName: undefined,
          email: undefined,
          mobile: undefined,
          code: undefined,
          field105: undefined,
          name: undefined,
          privince: undefined,
          city: undefined,
          district: undefined,
        },
        rules: {

          businessLicenseRegistrationNumber: [{
            required: true,
            message: '请输入营业执照注册号',
            trigger: 'blur'
          }],

          userName: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          email: [{
            required: true,
            message: '请输入Email',
            validator: (rule, value, callback) => {
              const regExp = /^.+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
              if (!regExp.test(value)) {
                callback(new Error('请输入正确的邮箱'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }],
          mobile: [{
            required: true,
            validator: (rule, value, callback) => {
              const regExp = /^(0|86|17951)?(1[1-9])[0-9]{9}$/
              if (!regExp.test(value)) {
                callback(new Error('请输入正确的手机号'))
              } else {
                callback()
              }
            },
            message: '请输入手机号',
            trigger: 'blur'
          }],
          code: [{
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }],
          name: [{
            required: true,
            message: '请输入公司名称',
            trigger: 'blur'
          }],
          privince: [{
            required: true,
            type: 'string',
            message: '请至少选择一个省',
            trigger: 'blur'
          }],
          city: [{
            required: true,
            type: 'string',
            message: '请至少选择一个市',
            trigger: 'blur'
          }],
          district: [{
            required: true,
            type: 'string',
            message: '请至少选择一个区',
            trigger: 'blur'
          }],
        },
        privinceOptions: [],
        cityOptions: [],
        districtOptions: [],
      }
    },
    methods: {
      entrySuccess() {
        // this.dialogVisible = false;
        window.location.reload();
      },
      proviceChage() {
        this.getCityOptions();
      },
      cityChage() {
        this.getDistrictOptions();
      },
      ticketing() {
        this.timer = setInterval(() => {
          if(this.codeTime === 1) {
            this.getCoding = true;
            this.codeTime = 60;
            clearInterval(this.timer);
          }
          this.codeTime = --this.codeTime;
        }, 1000);
      },
      getMobileCode() {
        if(!(/^1(3|4|5|7|8|9)\d{9}$/).test(this.formData.mobile)) {
          this.$toast({ message: '请输入正确手机号', position: 'middle' })
          return
        }
        if(!this.getCoding) return;
        // this.getCoding = false;
        // this.ticketing();
        GetCode({
          mobile: this.formData.mobile
        }).then((res) => {
          if(res.code === 106) {

          } else {
            this.getCoding = false;
            this.ticketing();
          }
          this.$toast({ message: res.msg, position: 'middle' })
          // this.$toast({ message: '验证码已发送成功', position: 'middle' })
        })
      },
      getBanner() {
        GetBannerList().then(data => {
          if(data && data.length) {
            data.forEach(item => {
              item.targetPath = '/EntryPlatform';
            })
            this.sliders = [...data];
            // 获取图片高度
            if(data[0] && data[0].imageUrl) {
              this.loadImg(this.baseUrl + this.sliders[0].imageUrl, () => {
                this.$nextTick(() => {
                  const ele = document.querySelector('.slider_img')
                  ele && (this.sliderStyle = {...getComputedStyle(document.querySelector('.slider_img'), null)})
                })
              });
            }
          }
        })
      },
      loadImg(url, cb) {
        const oImg = new Image();
        oImg.onload = () => {
          cb && cb();
        };
        oImg.src = url;
      },
      submitForm() {
        if (!this.checked) {
          this.$toast({ message: '请先阅读并同意用户协议和隐私政策', position: 'middle' })
          return;
        }
        this.$refs['elForm'].validate(valid => {
          if (!valid) return
          CompanyAdd({
            ...this.formData
          }).then(() => {
            // this.dialogVisible = true;
            // this.$toast({ message: '平台入驻信息提交成功', position: 'middle' })
            // 清空表单并跳转登录
            this.formData = {
              userName: undefined,
              email: undefined,
              mobile: undefined,
              code: undefined,
              field105: undefined,
              name: undefined,
              privince: undefined,
              city: undefined,
              district: undefined,
            }
            window.open('http://b.andrnd.com/ids/#/login')
          })
        })
      },
      getPrivinceOptions() {
        GetProvinceList().then(data => {
          data.forEach(item => {
            item.value = item.id
            item.label = item.name
          });
          this.privinceOptions = [...data];
          this.cityOptions = [];
				  this.districtOptions = [];
          this.formData.city = undefined;
          this.formData.district = undefined;
        });
      },
      getCityOptions() {
        GetCityList({
          provinceId: this.formData.privince
        }).then(data => {
          data.forEach(item => {
            item.value = item.id
            item.label = item.name
          });
          this.cityOptions = [...data];
          this.districtOptions = [];
          this.formData.district = undefined;
        });
      },
      getDistrictOptions() {
        let privinceFilter = this.privinceOptions.filter(item => item.value === this.formData.privince);
        let cityFilter = this.cityOptions.filter(item => item.value === this.formData.city);
        GetCountyList({
          provinceId: this.formData.privince,
          cityCode: this.formData.city,
          provinceName: privinceFilter.length && privinceFilter[0].value,
          cityName: cityFilter.length && cityFilter[0].value
        }).then(data => {
          data.forEach(item => {
            item.value = item.id
            item.label = item.name
          });
          this.districtOptions = [...data];
        });
      },
      turnToTarget(item) {
        this.$router.push(item.targetPath)
        // 跳转到展厅页面，暂时注释掉
        // this.$router.push({path: "/exhibitionHall"})
      },
      changeCheckbox() {
        this.checked = !this.checked;
      },
      openDoc(fileName, docKey) {
        this.docTitle = fileName;
        this.docPath = docKey;
        this.docDialogVisible = true;
      }
    },
    mounted() {
      this.getBanner();
      this.getPrivinceOptions();
    },
    computed: {
        getDayCount() {
            const startDate = new Date('2024-10-15');
            const today = new Date();
            const diffTime = Math.abs(today - startDate);
            let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            // 计算每月闭门日
            const months = Math.floor(diffDays / 30);
            diffDays -= months * 2;

            // 计算春节等公共假期
            const year = today.getFullYear();
            // 根据农历计算春节日期
            const springFestival = getLunarNewYear(year);
            function getLunarNewYear(year) {
                // 2024年春节是2月10日
                if (year === 2024) return new Date(2024, 1, 10);
                // 2025年春节是1月29日
                if (year === 2025) return new Date(2025, 0, 29);
                // 其他年份默认2月1日
                return new Date(year, 1, 1);
            }
            if (today >= springFestival) {
                diffDays -= 11;
            }

            return diffDays;
        }
    },
  }
</script>
<style scoped>
.entry-platform-container {
  width: 100%;
  background-color: #fff;
  color: #000;
  font-family: Microsoft YaHei;
}
.slider_container {
  padding: 10px 0;
}
.platform-info {
  display: flex;
  max-width: 1620px;
  margin: 20px auto 60px;
}
.platform-input-info {
  width: 520px;
}
.platform-input-info h3 {
  height: 30px;
  line-height: 30px;
  font-size: 26px;
  padding: 0 0 16px 40px;
}
.platform-input-info h4 {
  font-size: 22px;
  height: 36px;
  line-height: 36px;
  padding-left: 40px;
}
.entry-platform-container >>> .el-row {
  margin: 20px;
}
.entry-platform-container >>> .el-col {
  padding: 0 !important;
  display: flex;
  position: relative;
  z-index: 99;
}
.entry-platform-container >>> .el-form-item {
  margin-bottom: 30px;
}
.entry-platform-container >>> .el-form-item__label {
  color: #333;
}
.entry-platform-container >>> .el-input__inner {
  /* border-color: #333; */
  /* border-radius: 0; */
}
.get-code-btn {
  margin-left: 10px;
  flex: 0 !important;
}
.get-code-btn >>> .el-form-item__content {
  margin-left: 0 !important;
}
.get-code-btn >>> .el-button--medium {
  padding: 10px !important;
}
.code-item >>> .el-form-item {
  flex: 1;
}
.platform-desc {
  flex: 1;
  margin-left: 100px;
  background-color: rgba(0, 0, 0, .03);
  background: url('../assets/other/add_bg.png') right bottom no-repeat;
  padding: 0 0 520px 134px;
  background-size: cover;
}
.submit {
  width: 100%;
  background-color: #205eab !important;
  border: none !important;
}
.platform-desc-info h3 {
  font-size: 26px;
  height: 30px;
  line-height: 30px;
  padding: 30px 0;
}
.platform-desc-info p {
  line-height: 34px;
  padding-left: 50px;
  font-size: 18px;
  color: #011627;
}
.platform-desc-info-text {
  font-size: 14px;
  color: #707171;
  line-height: 26px;
  padding: 10px 50px 0;
}
.platform-desc-info-text span {
  display: block;
  padding: 10px 0;
  width: 500px;
}
.slider_img {
  width: 100%;
}
.day-counter {
  position: absolute;
  top: 185px;
  left: 905px;
  transform: translate(-50%, -50%);
  /*background: rgba(255, 255, 255, 0.9);*/
  padding: 10px 15px;
  border-radius: 4px;
  text-align: center;
}

.day-number {
    font-size: 30px;
    font-weight: bold;
    color: #394556;
    font-family: Microsoft YaHei;
}
.mobile_code_button {
  background-color: #205eab !important;
  border: none !important;
}
.agreement-wrap {
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
}
.agreement-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin-right: 8px;
}
.ant-checkbox {
  position: relative;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  vertical-align: middle;
  outline: none;
  cursor: pointer;
}
.ant-checkbox-input {
  position: absolute;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.ant-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid #d9d9d9;
  background-color: #fff;
}
.ant-checkbox-inner:after {
  transform: rotate(45deg) scale(0);
  position: absolute;
  left: 4px;
  top: 1px;
  display: table;
  width: 5px;
  height: 8px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: " ";
  transition: all .1s cubic-bezier(.71,-.46,.88,.6);
}
.ant-checkbox-checked .ant-checkbox-inner {
  border-color: #205eab;
  background-color: #205eab;
}
.ant-checkbox-checked .ant-checkbox-inner:after {
  transform: rotate(45deg) scale(1);
  transition: all .2s cubic-bezier(.12,.4,.29,1.46) .1s;
}
.agreement-wrap a {
  color: #205eab;
  cursor: pointer;
  margin: 0 4px;
  text-decoration: none;
}
.agreement-wrap a:hover {
  text-decoration: underline;
}
</style>

<style>
/* 全局样式，确保对话框在最上层 */
.doc-dialog.el-dialog__wrapper {
  z-index: 9999 !important;
}
.doc-dialog .el-dialog {
  z-index: 9999 !important;
}
.doc-dialog >>> .el-dialog__body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 20px;
}
.doc-dialog >>> .el-dialog__header {
  background-color: #f5f5f5;
  padding: 15px 20px;
}
.doc-dialog >>> .el-dialog__title {
  font-size: 18px;
  font-weight: bold;
}
</style>
